import { render, staticRenderFns } from "./ContactDisplayAndEdit.vue?vue&type=template&id=2ca3dd2c&scoped=true&"
import script from "./ContactDisplayAndEdit.vue?vue&type=script&lang=js&"
export * from "./ContactDisplayAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContactDisplayAndEdit.vue?vue&type=style&index=0&id=2ca3dd2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca3dd2c",
  null
  
)

export default component.exports